import { useSearchParams } from 'react-router-dom';

export const useSetPaginationParamsV2 = () => {
  const [, setSearchParams] = useSearchParams();
  return (params: string) => setSearchParams(params, { replace: true });
};
